<template>
  <div
    v-if="isLaunched"
    ref="dashboard"
    style="display:none;">
    <header-bar>ダッシュボード</header-bar>
    <dashboard-private-message
      v-if="message"
      :message="message" />

    <div class="report-area">
      <payment-record
        v-if="isBtoB" />
    </div>

    <div
      v-if="subscriptionDefaulted"
      class="top-error">
      <p>
        配信し放題プランのお支払いの確認ができておりませんので楽曲の登録ができない状態です。<br>
        決済情報の更新をお願いいたします。
      </p>
      <div class="c-btn-wrap">
        <router-link
          :to="{name: 'settlement-method-change'}"
          class="c-btn">
          決済情報を更新する
          <span class="c-btn__icon-arrow"></span>
        </router-link>
      </div>
    </div>

    <div
      v-if="subscriptionCarrierFeePending"
      class="subscription-carrier-fee-pending-block">
      <h2>【重要なお知らせ】</h2>
      <p
        class="subscription-carrier-fee-pending-notification">
        配信し放題プランの料金改定に伴い、下記の期限までに決済情報の再登録が必要となります。<br>
        <br>
        <em>期限：2024年 2月29日 23時59分</em><br>
        <br>
        決済情報の再登録が完了するまで、支払い申請を含む一部のサービスをご利用いただくことができません。<br>
        お手数ですが、下記の「決済情報を更新する」より<span>決済情報の再登録をお願いいたします。</span><br>
        <br>
        期限内に決済情報の再登録が完了しない場合、楽曲の配信停止および退会の手続きを取らせていただきます。<br>
        退会に伴いまして、<span>残高に計上されている収益をお支払することができなくなります。</span><br>
        ご理解の程、よろしくお願い申し上げます。<br>
      </p>
      <div class="c-btn-wrap">
        <router-link
          :to="{name: 'settlement-method-change'}"
          class="c-btn">
          決済情報を更新する
          <span class="c-btn__icon-arrow"></span>
        </router-link>
      </div>
    </div>

    <campaign-notification
      v-if="isBtoC"
      :created-at="createdAt"
      :registered-at="registeredAt"
      :campaign-deadline="campaignDeadline" />

    <dashboard-information
      v-if="isBtoC"
      ref="information"></dashboard-information>
    <!-- 一度も契約した事の無いユーザ向けに表示 -->
    <dashboard-notification
      v-if="false && isBtoC && $store.state.auth.contract_plan===0
        && $store.state.auth.company.account_type===0" />

    <!-- 放送二次使用料の規約のダイアログ -->
    <secondary-usage-fee-for-broadcasts-terms-reminder-dialog
      v-if="appName === 'Zu-MAP'"
      :visible="showModal"
      @close="showModal = false"/>

    <narasu-ai-popup
      v-if="isBtoC" />

    <div
      ref="report_area"
      class="report-area">
      <dashboard-realtime-report
        :class="{ 'no-payment-width': !!company.enable_payment_request }">
      </dashboard-realtime-report>
      <dashboard-balance-report
        v-if="!!company.enable_payment_request">
      </dashboard-balance-report>
    </div>
    <div
      v-if="isBtoB"
      class="finalized-report-area">
      <dashboard-finalized-report />
    </div>
    <div
      v-if="isBtoB && showCopyrightReport() &&
        'copyright_reports' in totals && totals.copyright_reports.length > 0"
      class="finalized-report-area">
      <div
        class="pre-report">
        <div
          class="pre-report__title-wrap">
          <div
            class="pre-report__title">
            <svg
              class="icon-report svg-icon"
              viewBox="0 0 27.49 21.276">
              <path
                class="color1"
                d="M0,23H18v1H0ZM0,12V22H3V12Zm2,9H1V13H2ZM7,8V21H6V8H7M8,7H5V22H8V7Zm4,
                    6v8H11V13h1m1-1H10V22h3V12Zm4-4V21H16V8h1m1-1H15V22h3V7ZM17,2.5a.5.5,0,1,
                    1-.5-.5A.5.5,0,0,1,17,2.5Zm2,0a2.491,2.491,0,0,1-3.821,2.115L12.492,
                    7.382a1.5,1.5,0,1,1-2.26.324l-2.8-2.888a2.428,2.428,0,0,1-2.058-.1L2.636,
                    7.531A1.484,1.484,0,0,1,3,8.5,1.5,1.5,0,1,1,1.5,7a1.42,1.42,0,0,1,
                    .254.026L4.594,4.1a2.493,2.493,0,1,1,3.673.167l2.741,2.821A1.469,1.469,0,
                    0,1,11.488,7L14.462,3.94A2.5,2.5,0,1,1,19,2.5ZM2,8.5a.5.5,0,1,0-.5.5A.5.5,
                    0,0,0,2,8.5Zm6-6A1.5,1.5,0,1,0,6.5,4,1.5,1.5,0,0,0,8,2.5Zm4,6a.5.5,0,1,
                    0-.5.5A.5.5,0,0,0,12,8.5Zm6-6A1.5,1.5,0,1,0,16.5,4,1.5,1.5,0,0,0,18,
                    2.5ZM6.5,2a.5.5,0,1,0,.5.5A.5.5,0,0,0,6.5,2Z"/>
            </svg>
            著作権収益レポート
          </div>
        </div>
        <copyright-report-section
          :copyright-reports="totals.copyright_reports"/>
      </div>
    </div>
    <dashboard-backward-min-release-schedules
      v-if="$store.state.auth.company.account_type === 0"
      ref="backward_min_release_schedules" />
    <dashboard-min-release-schedules
      v-if="$store.state.auth.company.account_type === 0"
      ref="submit_mini_release_schedules" />
    <dashboard-submit-min-release-schedules
      v-if="$store.state.auth.company.account_type === 0 && !isBtoB && false"
      ref="mini_release_schedules" />
    <div
      v-if="$store.state.auth.company.account_type === 0"
      ref="registration_buttons"
      class="nav-area">
      <router-link
        :to="{ name: 'release-single' }"
        class="nav-area__item"
        href="">
        <div class="nav-area__item-icon">
          <svg
            class="icon-add_artist_db svg-icon"
            viewBox="0 0 110 110">
            <path
              class="color2"
              fill-rule="evenodd"
              d="M75.609,96.86H23.753a4.19,4.19,0,0,1-4.167-4.2V19.06a4.187,
              4.187,0,0,1,4.162-4.2H68.721c1.451,0,7.026,5.222,16.57,15.52a1,
              1,0,0,1-1.467,1.36c-6.382-6.887-13.753-14.271-15.2-14.88H23.753a2.182,
              2.182,0,0,0-2.167,2.194V92.66a2.187,2.187,0,0,0,2.172,2.2H73.769A15.029,
              15.029,0,0,0,75.609,96.86Zm9.949-62H72.384c-2.279,
              0-2.663-.894-2.663-2.9V20.66a1,1,0,1,0-2,0v11.3c0,2.1.483,4.9,4.663,
              4.9H83.558V71.148a14.651,14.651,0,0,1,2-.152Z" />
            <path
              class="color1"
              fill-rule="evenodd"
              d="M65.559,66.815v-25.8a1.156,1.156,0,0,0-.479-.938,1.127,1.127,0,0,
              0-1.035-.141L44.223,47.1a1.144,1.144,0,0,0-.751,1.079V70.611a5.627,
              5.627,0,0,0-4.058-.481c-3.282.707-5.853,3.5-5.853,6.353a4.153,4.153,
              0,0,0,1.527,3.277,5.193,5.193,0,0,0,3.328,1.1,6.938,6.938,0,0,0,
              1.471-.158c3.283-.707,5.853-3.5,5.853-6.353,
              0-.125-.028-.244-.037-.367h.034V56.154L63.3,49.806V63.445a5.62,5.62,
              0,0,0-4.059-.481c-3.282.707-5.853,3.5-5.853,6.352a4.155,4.155,0,0,0,
              1.527,3.278,5.193,5.193,0,0,0,3.328,1.1v-.006a7.064,7.064,0,0,0,
              1.471-.152c3.283-.707,5.853-3.5,5.853-6.353,
              0-.125-.028-.245-.037-.368ZM39.413,78.457a3.428,3.428,0,0,1-2.9-.483,
              1.838,1.838,0,0,1-.687-1.493c0-1.754,1.858-3.636,4.058-4.11a4.869,4.869,
              0,0,1,1.007-.111v-.006a2.96,2.96,0,0,1,1.893.6,1.843,1.843,0,0,1,.687,
              1.493C43.471,76.1,41.613,77.983,39.413,78.457Zm19.823-7.166a3.425,3.425,
              0,0,1-2.9-.483,1.838,1.838,0,0,1-.688-1.494c0-1.754,1.858-3.635,
              4.058-4.109a4.794,4.794,0,0,1,1.007-.111v-.007a2.965,2.965,0,0,1,
              1.894.6,1.843,1.843,0,0,1,.688,1.494C63.3,68.935,61.436,70.817,59.236,
              71.291ZM63.3,47.371,45.737,53.72V48.98L63.3,42.632ZM91.572,85.86a1,1,0,
              0,1-1,1h-4v4a1,1,0,1,1-2,0v-4h-4a1,1,0,0,1,0-2h4v-4a1,1,0,0,1,2,0v4h4A1,
              1,0,0,1,91.572,85.86ZM85.572,73A12.865,12.865,0,1,0,98.436,85.86,12.879,
              12.879,0,0,0,85.572,73Zm0,23.865a11,11,0,1,1,11-11A11.012,11.012,0,0,1,
              85.572,96.86Z" />
          </svg>
        </div>
        <div class="nav-area__item-text">
          シングル配信（1曲）
          <span class="c-btn__icon-arrow c-btn__icon-arrow--def"></span>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'release-album' }"
        class="nav-area__item">
        <div class="nav-area__item-icon">
          <svg
            class="icon-add_album_db svg-icon"
            viewBox="0 0 110 110">
            <path
              class="color2"
              fill-rule="evenodd"
              d="M81.708,69.828c-.057,0-.112.008-.169.009V34.693H70.4c-4.17,
              0-4.652-2.8-4.652-4.9v-11.3a1,1,0,1,1,2,0v11.3c0,2.25.594,2.9,2.652,
              2.9H83.539v37.26A14.959,14.959,0,0,0,81.708,69.828Zm12.986,22.08a14.931,
              14.931,0,0,1-8.034,6.783h1.9c.109.007.217.01.325.01A5.832,5.832,0,0,0,
              94.7,93.187a4.9,4.9,0,0,0,0-.694Zm0-46.215a1,1,0,0,0-2,0V74.717a14.9,14.9,
              0,0,1,2,2.762Zm-64.808,39a2.182,2.182,0,0,1-2.164-2.2V16.887a2.18,2.18,0,
              0,1,2.158-2.194H66.645c1.447.612,8.8,7.995,15.158,14.879a1,1,0,0,0,
              1.469-1.358c-9.518-10.3-15.079-15.521-16.527-15.521H29.873a4.183,4.183,0,
              0,0-4.151,4.2V82.486a4.185,4.185,0,0,0,4.158,4.207H66.994a14.824,14.824,0,
              0,1-.151-2Zm58.9-45a1,1,0,0,0-2,0l0,31.05a14.82,14.82,0,0,1,2,.884Zm-52.926,
              51a1,1,0,1,0,0,2H69.2a14.844,14.844,0,0,1-1.08-2Zm5.9,6a1,1,0,1,0,0,
              2H76.757a14.8,14.8,0,0,1-3.785-2Z" />
            <path
              class="color1"
              fill-rule="evenodd"
              d="M81.708,71.828A12.865,12.865,0,1,0,94.572,84.693,12.88,12.88,0,0,0,81.708,
              71.828Zm0,23.865a11,11,0,1,1,11-11A11.012,11.012,0,0,1,81.708,95.693Zm6-11a1,
              1,0,0,1-1,1h-4v4a1,1,0,1,1-2,0v-4h-4a1,1,0,0,1,0-2h4v-4a1,1,0,0,1,2,0v4h4A1,1,
              0,0,1,87.708,84.693Zm-17-27.119a1,1,0,0,0,2,
              0c0-3.526-1.093-4.5-2.638-5.488a5.435,5.435,0,0,1-2.446-2.781,1,1,0,0,
              0-1.916.4V66.029A4.2,4.2,0,0,0,63,65.813c-2.406.511-4.292,2.543-4.292,
              4.626a3.079,3.079,0,0,0,1.152,2.44,3.9,3.9,0,0,0,2.478.814,5.148,5.148,0,0,0,
              1.078-.115c2.406-.511,4.292-2.542,4.292-4.625,0-.058-.015-.114-.018-.172,
              0-.031.018-.057.018-.088V52.84a10.092,10.092,0,0,0,1.283.929C70.1,54.474,70.708,
              54.868,70.708,57.574ZM63,71.621a2.287,2.287,0,0,1-1.881-.3,1.085,1.085,0,0,
              1-.411-.886c0-1.136,1.24-2.359,2.708-2.67a3.184,3.184,0,0,1,.66-.072v0a1.942,1.942,
              0,0,1,1.221.367,1.091,1.091,0,0,1,.411.886C65.708,70.087,64.468,71.309,63,
              71.621ZM58.69,56.785a.82.82,0,0,0,.018-.086V37.707a1,1,0,0,0-1.336-.941l-14,5a1,1,0,
              0,0-.664.942V47.7h0V59.033A4.218,4.218,0,0,0,40,58.817c-2.406.511-4.292,
              2.543-4.292,4.626a3.077,3.077,0,0,0,1.152,2.436,3.9,3.9,0,0,0,2.478.814,5.143,5.143,
              0,0,0,1.078-.11c2.406-.511,4.292-2.543,4.292-4.626,
              0-.058-.015-.113-.018-.171a.838.838,0,0,0,.018-.087V48.4l12-4.286V54.03A4.2,4.2,0,0,
              0,54,53.814c-2.406.511-4.292,2.542-4.292,4.625a3.079,3.079,0,0,0,1.152,2.44,3.9,3.9,
              0,0,0,2.478.814V61.7a5.217,5.217,0,0,0,1.078-.116c2.406-.511,4.292-2.543,
              4.292-4.626C58.708,56.9,58.693,56.843,58.69,56.785ZM40,64.621a2.283,2.283,0,0,
              1-1.881-.3,1.085,1.085,0,0,1-.411-.886c0-1.136,1.24-2.359,2.708-2.67a3.184,3.184,0,0,
              1,.66-.072V60.7a1.947,1.947,0,0,1,1.221.364,1.091,1.091,0,0,1,.411.886C42.708,63.087,
              41.468,64.309,40,64.621Zm4.708-18.34V43.412l12-4.284V42ZM54,59.621a2.291,2.291,0,0,
              1-1.881-.3,1.085,1.085,0,0,1-.411-.886c0-1.136,1.24-2.358,2.708-2.67a3.184,3.184,0,
              0,1,.66-.072v.01a1.945,1.945,0,0,1,1.221.361,1.092,1.092,0,0,1,.411.886C56.708,
              58.086,55.468,59.309,54,59.621Z" />
          </svg>
        </div>
        <div class="nav-area__item-text">
          アルバム配信（2曲以上）
          <span class="c-btn__icon-arrow c-btn__icon-arrow--def"></span>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'release-index' }"
        class="nav-area__item">
        <div class="nav-area__item-icon">
          <svg
            class="icon-add_artist_db svg-icon"
            viewBox="0 0 110 110">
            <path
              class="color1"
              fill-rule="evenodd"
              d="M68.984,24.944,50.289,30.251a1,1,0,0,0-.728.9L48.08,53.045a5.187,5.187,0,0,
              0-3.738-.729c-3.044.435-5.569,2.807-5.744,5.4a3.755,3.755,0,0,0,1.189,3.057,
              4.893,4.893,0,0,0,3.387,1.221v0a6.667,6.667,0,0,0,.936-.07c3.044-.435,5.569-2.807,
              5.744-5.4.009-.112-.01-.222-.011-.334l.034,0,1.189-17.644,16.646-4.726-.941,
              13.913a5.181,5.181,0,0,0-3.734-.727c-3.044.435-5.57,2.808-5.744,5.4a3.757,3.757,0,
              0,0,1.188,3.058,4.912,4.912,0,0,0,3.387,1.221,6.782,6.782,0,0,0,
              .933-.064c3.045-.435,5.57-2.808,5.745-5.4.009-.114-.01-.226-.011-.339l.033,0,
              1.684-24.909a1.011,1.011,0,0,0-.368-.851A1,1,0,0,0,68.984,24.944ZM43.827,
              59.933A3.229,
              3.229,0,0,1,41.15,59.3a1.752,1.752,0,0,1-.553-1.446c.11-1.622,1.954-3.243,
              4.028-3.543a4.7,4.7,0,0,1,.661-.049v0a2.922,2.922,0,0,1,2.016.68,1.758,1.758,0,0,1,
              .554,1.445C47.745,58.014,45.9,59.633,43.827,59.933ZM51.21,36.418l.3-4.421,
              16.648-4.726-.3,4.421Zm11.312,18.21a3.23,3.23,0,0,1-2.677-.635,1.749,1.749,0,0,
              1-.553-1.445c.109-1.623,1.954-3.242,4.027-3.542a4.44,4.44,0,0,1,.662-.049A2.916,
              2.916,0,0,1,66,49.641a1.749,1.749,0,0,1,.554,1.445C66.44,52.709,64.6,54.329,62.522,
              54.628ZM38.747,43.066c-.014-.1-.051-.185-.073-.279l.035-.006L36,25.175a10.1,10.1,0,
              0,0,1.73.92c1.313.583,2.106.936,2.57,3.955a1,1,0,1,0,
              1.981-.307c-.588-3.815-1.921-4.683-3.741-5.492a6.149,6.149,0,0,1-3.178-2.671,1,1,0,
              0,0-1.837.7L36.3,40.334a4.518,4.518,0,0,0-3.075.17c-2.493.953-4.176,3.45-3.832,
              5.688A3.316,3.316,0,0,0,31.011,48.6a3.957,3.957,0,0,0,2.014.518h0a5.321,5.321,0,0,0,
              1.89-.364C37.408,47.8,39.091,45.3,38.747,43.066ZM34.2,46.876a2.616,2.616,0,0,
              1-2.186-.013,1.3,1.3,0,0,1-.646-.974c-.2-1.294.976-2.9,2.564-3.5a3.3,3.3,0,0,1,
              1.178-.232h0a1.993,1.993,0,0,1,1.007.246,1.3,1.3,0,0,1,.646.974C36.965,44.668,35.791,
              46.269,34.2,46.876ZM88.511,25.259a6.188,6.188,0,0,1-2.271-3.485,1.015,1.015,0,0,
              0-1.031-.734,1,1,0,0,0-.926.864L81.732,39.985a4.539,4.539,0,0,
              0-2.993-.726c-2.66.184-4.992,2.083-5.308,4.324a3.325,3.325,0,0,0,.853,2.776,4.42,
              4.42,0,0,0,3.289,1.3c.133,0,.273,0,.4-.012,2.66-.183,4.992-2.084,
              5.308-4.323.014-.1.005-.192.011-.289l.029.005L85.813,25.4a10.206,10.206,0,0,0,1.39,
              1.383c1.088.942,1.745,1.51,1.318,4.536a1,1,0,1,0,1.984.284C91.044,27.783,90.018,
              26.563,88.511,25.259ZM81.3,43.037c-.182,1.3-1.767,2.484-3.461,2.6a2.609,2.609,0,0,
              1-2.089-.65,1.307,1.307,0,0,1-.336-1.12c.182-1.294,1.767-2.483,3.461-2.6a2.578,
              2.578,0,0,1,.262-.009h0a2.474,2.474,0,0,1,1.826.66A1.307,1.307,0,0,1,81.3,43.037Z" />
            <path
              class="color2"
              fill-rule="evenodd"
              d="M95.691,69.063,84.624,58.612c-.013-.012-.029-.019-.043-.03a.93.93,0,0,
              0-.106-.075.852.852,0,0,0-.145-.079q-.027-.016-.054-.03L72.629,54.184a1,1,0,0,
              0-1.285.591.988.988,0,0,0,.588,1.268l.012.005,9.071,3.283-25.969,9.4-25.966-9.4,
              6-2.171a.991.991,0,0,0,.6-1.264l0-.009a1.007,1.007,0,0,0-1.285-.592l-8.575,
              3.1a.468.468,0,0,0-.054.03.836.836,0,0,0-.144.079.781.781,0,0,
              0-.106.075c-.014.011-.03.018-.043.03L14.405,69.056a.987.987,0,0,0-.042,1.4,1,1,0,0,0,
              .319.226L41.706,82.849a1.011,1.011,0,0,0,1.1-.184l11.24-10.571V104.6L27.163,
              94.874V78.057a1,1,0,0,0-2,0V95.569c0,.008,0,.015,0,.023a.96.96,0,0,0,.045.223.5.5,0,
              0,0,.149.316.917.917,0,0,0,.109.149.961.961,0,0,0,.141.094,1.024,1.024,0,0,0,
              .188.114c.008,0,.013.01.021.013l28.887,10.451a1.016,1.016,0,0,0,.688,0L84.282,
              96.5c.009,0,.014-.01.022-.013a1.1,1.1,0,0,0,.188-.114,1.192,1.192,0,0,0,.141-.094,
              1.053,1.053,0,0,0,.109-.149,1.035,1.035,0,0,0,.109-.161,1.066,1.066,0,0,0,.039-.155,
              1.017,1.017,0,0,0,.046-.223V75.405l10.48-4.72a.989.989,0,0,0,.5-1.305A.975.975,0,0,0,
              95.691,69.063ZM41.915,80.772,16.856,69.486,26.4,60.474l21.591,7.812,5.193,
              1.879Zm41.015,14.1L56.046,104.6V72.094L67.284,82.672a1.011,1.011,0,0,0,
              1.1.184l14.539-6.55V94.874Zm-14.754-14.1L56.908,70.165,62.1,68.286l21.591-7.812,
              9.543,9.012Zm34.87-32.745
              h-3v3h-2v-3h-3v-2h3v-3h2v3h3Zm-31-42h3v2h-3v3h-2v-3h-3v-2h3v-3h2Zm-22,
              6h3v2h-3v3h-2v-3h-3v-2h3v-3h2Zm-34,21h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z" />
          </svg>
        </div>
        <div class="nav-area__item-text">
          マイリリース
          <span class="c-btn__icon-arrow c-btn__icon-arrow--def"></span>
        </div>
      </router-link>
      <router-link
        :to="{ name : 'artist-create' }"
        class="nav-area__item">
        <div class="nav-area__item-icon">
          <svg
            class="icon-add_artist_db svg-icon"
            viewBox="0 0 110 110">
            <path
              class="color2"
              fill-rule="evenodd"
              d="M55.117,49.06c-8.546,0-15.5-8.336-15.5-18.582,0-9.505,5.938-15.41,15.5-15.41s15.5,
              5.9,15.5,15.41C70.617,40.724,63.662,49.06,55.117,49.06Zm0-31.984c-8.45,0-13.5,
              5.01-13.5,13.4,0,9.139,6.054,16.574,13.5,16.574s13.5-7.433,13.5-16.572C68.617,22.086,
              63.568,17.076,55.117,17.076Z" />
            <path
              class="color1"
              fill-rule="evenodd"
              d="M82.617,72.961a14.954,14.954,0,0,0-1.981,
            1.29V68.005A14.919,14.919,0,0,0,65.757,53.068h-.948l-9.5,9.246a.994.994,0,0,1-1.387,
            0l-9.5-9.246h-.943A14.92,14.92,0,0,0,28.6,68V86.34a8.809,8.809,0,0,0,8.745,
            8.728V75.255a1,1,0,0,1,1.992-.179,1.07,1.07,0,0,1,0,.179V96.068a1,1,0,0,1-1,
            1h-.87A10.811,10.811,0,0,1,26.605,86.342V68.005A16.918,16.918,0,0,1,43.474,
            51.068h1.349a1,1,0,0,1,.694.282l9.1,8.853,9.1-8.853a1,1,0,0,1,.694-.282h1.351A16.917,
            16.917,0,0,1,82.617,68.005ZM71.952,95.067h-.065V75.255a1,1,0,0,0-2,0v19.9l.078.992a1,
            1,0,0,0,.994.921h.982a10.659,10.659,0,0,0,5.983-1.853,14.935,14.935,0,0,
            1-1.119-1.646A8.671,8.671,0,0,1,71.952,95.067Zm17.665-21a12,12,0,1,0,12,
            12A12.013,12.013,0,0,0,89.617,74.068Zm0,22.26a10.26,10.26,0,1,1,10.26-10.26A10.271,
            10.271,0,0,1,89.617,96.328Zm6-10.26a1,1,0,0,1-1,1h-4v4a1,1,0,0,1-2,0v-4h-4a1,1,0,0,
            1,0-2h4v-4a1,1,0,0,1,2,0v4h4A1,1,0,0,1,95.617,86.068Z" />
          </svg>
        </div>
        <div class="nav-area__item-text">
          アーティスト登録
          <span class="c-btn__icon-arrow c-btn__icon-arrow--def"></span>
        </div>
      </router-link>
    </div>
    <!-- リリース一覧のコンポーネント -->
    <dashboard-my-release
      v-if="$store.state.auth.company.account_type === 0"
      ref="my_release" />
    <!-- アーティスト一覧のコンポーネント -->
    <dashboard-my-artist
      v-if="$store.state.auth.company.account_type === 0"
      ref="my_artist" />
    <dashboard-information
      v-if="isBtoB"
      ref="information"></dashboard-information>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import DashboardInformation from './Dashboard/Information'
import DashboardMyArtist from './Dashboard/MyArtist'
import DashboardMyRelease from './Dashboard/MyRelease'
import DashboardRealtimeReport from './Dashboard/RealtimeReport'
import DashboardBalanceReport from './Dashboard/BalanceReport'
import DashboardFinalizedReport from './Dashboard/FinalizedReport'
import DashboardMinReleaseSchedules from './Dashboard/MinReleaseSchedules'
import DashboardBackwardMinReleaseSchedules from './Dashboard/BackwardMinReleaseSchedules'
import DashboardSubmitMinReleaseSchedules from './Dashboard/SubmitMinReleaseSchedules'
import CampaignNotification from './Dashboard/CampaignNotification'
import DashboardNotification from './Dashboard/Notification'
import DashboardPrivateMessage from './Dashboard/PrivateMessage'
import HeaderBar from '../HeaderBar'
import PaymentRecord from './Dashboard/PaymentRecord'
import SecondaryUsageFeeForBroadcastsTermsReminderDialog from '../Static/SecondaryUsageFeeForBroadcastsTermsReminderDialog'
import CopyrightReportSection from '../Copyright/Common/CopyrightReportSection'
import NarasuAIPopup from '../Static/NarasuAIPopup'

export default {
  components: {
    HeaderBar,
    DashboardInformation,
    DashboardMyArtist,
    DashboardMyRelease,
    DashboardRealtimeReport,
    DashboardBalanceReport,
    DashboardFinalizedReport,
    DashboardMinReleaseSchedules,
    DashboardBackwardMinReleaseSchedules,
    DashboardSubmitMinReleaseSchedules,
    DashboardNotification,
    DashboardPrivateMessage,
    CampaignNotification,
    PaymentRecord,
    // eslint-disable-next-line vue/no-unused-components
    'secondary-usage-fee-for-broadcasts-terms-reminder-dialog': SecondaryUsageFeeForBroadcastsTermsReminderDialog,
    CopyrightReportSection,
    'narasu-ai-popup': NarasuAIPopup,
  },
  data() {
    return {
      reportedDate: null,
      company: [],
      campaignDeadline: -1,
      createdAt: null,
      registeredAt: null,
      message: '',
      showModal: false,
      totals: {},
      permission: null,
    }
  },
  computed: {
    ...mapGetters('auth', ['subscriptionDefaulted', 'isSubscriber', 'subscriptionCarrierFeePending']),
  },
  mounted() {
    this.fetchCompanies()
    this.fetchTotal()
    this.reportedDate = moment().format('YYYY.MM.DD HH:00:00')
    this.$store.commit('showSidebar')
    if (this.isBtoC && !this.isSubscriber) this.fetchCampaign()

    // 未契約のユーザはダッシュボードの配置を変更する
    if (this.isBtoC && this.$store.state.auth.contract_plan === 0
      && this.$store.state.auth.company.account_type === 0) {
      // this.$el.insertBefore(this.$refs.report_area, this.$refs.information.$el)
      this.$el.insertBefore(this.$refs.registration_buttons,
        // サブミット実施時は現在非表示
        // this.$refs.mini_release_schedules.$el,
        this.$refs.submit_mini_release_schedules.$el)
    }
    this.$refs.dashboard.style.display = 'block'
  },
  methods: {
    async fetchCompanies() {
      const { data } = await window.axios.get(`/api/client/users/${this.$store.state.auth.id}`)
      this.company = data.company
      this.message = data.message
      this.permission = data.permission

      // 一時的に無効
      // if (data.permission === 0 && this.appName === 'Zu-MAP' && this.checkZuMAPOpenDialog()) {
      //   const now = Date.now()
      //   localStorage.setItem('dialog_shown_at', now.toString())
      //   this.showModal = true
      // }
    },
    async fetchCampaign() {
      const { data } = await window.axios.get('/api/client/user/')
      if (Object.prototype.hasOwnProperty.call(data.subscription, 'campaign_deadline')) {
        this.campaignDeadline = data.subscription.campaign_deadline
        this.createdAt = moment(data.created_at).format('YYYY年MM月DD日')
        this.registeredAt = moment(data.registered_date).format('YYYY年MM月DD日')
      }
    },
    checkZuMAPOpenDialog() {
      const stored = localStorage.getItem('dialog_shown_at')
      const shownAt = stored ? parseInt(stored, 10) : null
      // 一度も表示されていないなら true
      if (this.company.secondary_usage_fee_for_broadcasts_terms_agreed === -2) {
        return true
      }

      const now = Date.now()
      const diff = now - shownAt

      // 24時間（ミリ秒）以上経っていれば true
      return this.company.secondary_usage_fee_for_broadcasts_terms_agreed <= -1
        && diff >= 24 * 60 * 60 * 1000
    },
    async fetchTotal() {
      const { data } = await window.axios.get('/api/client/reports/latest-finalized')
      this.totals = data
    },
    showCopyrightReport() {
      if (this.isBtoC) {
        return true
      }
      if (this.permission === 9) {
        return true
      }
      // 2025/5/30 0:00:00 以降は true
      return moment()
        .isAfter('2025-05-30 00:00:00')
    },
  },
}
</script>

<style scoped>
.anniversary-notification {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
@media screen and (min-width: 896px) {
  .anniversary-notification {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    max-width: 1120px;
    min-height: 96px;
  }
}

@media screen and (max-width: 895px) {
  .anniversary-notification {
    margin-bottom: 0;
  }
}
</style>
